import { Primitive } from '../../react-primitive/dist/index.module.js';
import * as React from 'react';
import _extends from '../../../@babel/runtime/helpers/esm/extends.js';

const Arrow=/*#__PURE__*/React.forwardRef(((o,i)=>{const{children:n,width:s=10,height:m=5,...p}=o;return React.createElement(Primitive.svg,_extends({},p,{ref:i,width:s,height:m,viewBox:"0 0 30 10",preserveAspectRatio:"none"}),o.asChild?n:/*#__PURE__*/React.createElement("polygon",{points:"0,0 30,0 15,10"}))}));const Root=Arrow;

export { Arrow, Root };
